<template>
  <div>
    <el-form-item class="ai-items" label="问题列表">
      <div class="ai-item-wrap" v-for="(item, key) in form.list" :key="item.id">
        <div class="ai-item">
          <el-input :value="item.id" class="ai-item-no" title="数据唯一值，自动生成" disabled/>
          <el-input v-model="item.text" placeholder="输入阅读理解问题"/>
          <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
          <el-button icon="el-icon-plus" tabindex="-1" @click="addItem(key)"></el-button>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import baseList from "./base-list.js";

export default {
  name: "ai_rc_form",
  props: {
    form: Object
  },
  data() {
    return {
      type: 0,
    }
  },
  mixins: [baseList],
  watch: {
    form: {
      immediate: true,
      handler(val) {
        if (!val.list) {
          val.list = [];
        }
        if (val.length < 1) {
          this.addItem(0);
        }
      }
    }
  }
}
</script>